import { CustomField, Product } from '@models';

interface Cluster {
  clusterName: string;
  products?: {
    id: number;
    sku: string;
    name: string;
  }[];
}

interface LocalProduct {
  id: number;
  sku: string;
  name: string;
}

const formatProductClusters = (deletedProducts: Product[], newProducts: Product[], clusterName: string): Product[] => {
  const formattedProducts: Product[] = [];

  deletedProducts.forEach((product) => {
    const updatedProduct: Product = {
      ...product,
      custom_fields: product.custom_fields.map((field) => {
        const newField = { ...field };

        if (newField.name === 'cluster') {
          const clusters = newField.value.split(',').map((cluster) => cluster.trim());
          const updatedClusters = clusters.filter((cluster) => cluster !== clusterName);

          if (updatedClusters.length >= 1) {
            newField.value = updatedClusters.join(', ');
          } else {
            newField.value = '-';
          }
        }

        return newField;
      }),
    };

    formattedProducts.push(updatedProduct);
  });

  newProducts.forEach((product) => {
    let clusterFieldExists = false;

    const updatedProduct: Product = {
      ...product,
      custom_fields: product.custom_fields.map((field) => {
        const newField = { ...field };

        if (newField.name === 'cluster') {
          clusterFieldExists = true;

          const clusters = newField.value.split(',').map((cluster) => cluster.trim());

          if (!clusters.includes(clusterName)) {
            clusters.push(clusterName);
          }

          newField.value = clusters.filter((cluster) => cluster !== '-').join(', ');
        }

        return newField;
      }),
    };

    if (!clusterFieldExists) {
      const newClusterField: CustomField = {
        name: 'cluster',
        value: clusterName,
      };

      updatedProduct.custom_fields.push(newClusterField);
    }

    formattedProducts.push(updatedProduct);
  });

  return formattedProducts;
};

const findDeletedAndNewProducts = (
  cluster: Cluster,
  localProducts: LocalProduct[],
  products: Product[],
): { deletedProducts: Product[]; newProducts: Product[] } => {
  if (!cluster.products) {
    const newProducts = products.filter((product) => localProducts.some((newProduct) => newProduct.id === product.id));

    return { deletedProducts: [], newProducts: newProducts };
  }

  const clusterProductIds = cluster.products.map((product) => product.id);
  const newProductIds = localProducts.map((localProduct) => localProduct.id);

  const deletedProductIds = cluster.products.filter((product) => !newProductIds.includes(product.id));
  const newlyAddedProductIds = localProducts.filter((product) => !clusterProductIds.includes(product.id));

  const deletedProducts = products.filter((product) => deletedProductIds.some((deletedProduct) => deletedProduct.id === product.id));
  const newProducts = products.filter((product) => newlyAddedProductIds.some((newProduct) => newProduct.id === product.id));

  return { deletedProducts, newProducts };
};

export { formatProductClusters, findDeletedAndNewProducts };
